export const alertIconColorByType = {
  success: 'whitePrimary',
  info: 'blueSecondary',
  warning: 'warningPrimary',
  error: 'whitePrimary',
  expandedWarning: 'warningPrimary',
}

export const bannerDecorationIconByType = {
  success: '',
  info: 'info-banner-pattern',
  warning: 'warning-banner-pattern',
  expandedWarning: '',
  error: '',
  admin: 'zone-alert-pattern', // move this to zone alerts, can be hardcoded
}

export const alertIconByType = {
  success: 'check-mark-only',
  info: 'alert_info_i_round_solid',
  warning: 'warning_solid_black',
  error: 'alert_banner_error_diamond_cross',
}

export const alertMessagePrefixByType = {
  success: 'You got it! ',
  info: 'Note: ',
  warning: 'Heads up: ',
  error: 'Whoops! ',
}

export const alertWithDecoration = ['warning', 'info']
